import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Global } from './Global';

@Injectable({
    providedIn: 'root'
})
export class EntitySharingService {
    
    private _http = inject(HttpClient)
    private _url = Global.url_user
    private _headers = new HttpHeaders().set('Content-Type', 'application/json');

    setEntity(entity: any){
        return this._http.patch(this._url + 'set-entity', entity, { headers: this._headers })
    }
}

